import * as types from './types'
import SubscriptionsResource from '@/common/resources/Subscriptions'

export const actions = {
	getSubscriptions ({ commit }) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			commit(types.CLEAR_SUBSCRIPTIONS)
			SubscriptionsResource.getSubscriptions().then((result) => {
				if (result.data.success) {
					commit(types.LAST_PAYMENT_FAIL_INFO, result.data.lastPaymentFailInfo)
					result.data.subscriptions.forEach((subscription) => {
						commit(types.ADD_SUBSCRIPTION, subscription)
					})
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant la récupération des abonnements'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	getSubscription ({ commit }, id) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			SubscriptionsResource.getSubscription(id).then((result) => {
				if (result.data.success) {
					commit(types.REPLACE_SUBSCRIPTION, result.data.subscriptions[0])
					commit('LOADER_OUT')
					resolve(result.data.subscriptions[0])
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant la récupération de l\'abonnement ' + id))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	createSubscription ({ commit }, subscription) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			SubscriptionsResource.postSubscription({
				user_id: subscription.client.id,
				advisor_id: subscription.advisor.id,
				payment_type: subscription.payment_type.name,
				effect_date: subscription.effect_date,
				has_paid_first_charge: subscription.has_paid_first_charge
			}).then((result) => {
				if (result.data.success) {
					commit(types.ADD_SUBSCRIPTION, result.data.subscription)
					commit('LOADER_OUT')
					resolve(result.data.subscription)
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant la création de l\'abonnement'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	patchSubscription ({ commit }, subscription) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			SubscriptionsResource.updateSubscription(subscription.id, {
				user_id: subscription.client.id,
				advisor_id: subscription.advisor.id,
				payment_type: subscription.payment_type.name,
				effect_date: subscription.effect_date,
				has_paid_first_charge: subscription.has_paid_first_charge
			}).then((result) => {
				if (result.data.success) {
					commit(types.REPLACE_SUBSCRIPTION, result.data.subscription)
					commit('LOADER_OUT')
					resolve(result.data.subscription)
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant la création de l\'abonnement'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	cancelSubscription ({ commit }, subscription) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			SubscriptionsResource.cancelSubscription(subscription.id).then((result) => {
				if (result.data.success) {
					// commit(types.CANCEL_SUBSCRIPTION, subscription.id)
					commit('LOADER_OUT')
					resolve({})
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant l\'annulation de l\'abonnement'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	confirmPayment ({ commit }, data) {
		return new Promise((resolve, reject) => {
			SubscriptionsResource.confirmPayment(data)
		})
	}}



// WEBPACK FOOTER //
// ./src/common/store/Subscriptions/actions.js